import { PianoKeysIcon as PhosphorPianoKeysIcon } from "@phosphor-icons/react/dist/ssr/PianoKeys";

import { createAppIcon } from "@/components/createAppIcon";

export const PianoIcon = /* @__PURE__ */ createAppIcon(PhosphorPianoKeysIcon);
